import {useRpcSender} from "../../RpcSender";
import {CreateInquiryRequest, CreateInquiryResponse} from "../../compiled";
import {RpcState} from "../../util/RpcState";
import {useRef, useState} from "react";
import {ActionButton} from "../../util/UI/ActionButton";

type Props = {
  businessId: string,
}

export const NewClientInquiry = (props: Props) => {

  const rpcSender = useRpcSender()

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})

  const textArea = useRef<HTMLTextAreaElement>(null);
  
  
  const send = () => {

    let request = CreateInquiryRequest.encode(new CreateInquiryRequest({
      businessId: props.businessId,
      message: textArea.current?.value,
    })).finish();

    rpcSender.send('create_inquiry', request)
        .then(bytes => {
          const response = CreateInquiryResponse.decode(bytes);
          if (response.okay) {
            setRpcState({state: 'success'})
          } else {
            setRpcState({state: 'error'})
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: e.toString()})
        });
  }

  return <div style={{display: 'flex', flexDirection: "column", alignItems: 'center', textAlign: 'start', gap: 20}}>
    <b>This business requests that you inquire before you can book with them.</b>

    {rpcState.state != 'success' && <>

      <div>Please tell us what you're looking for.</div>

      <textarea ref={textArea}
          style={{width: 300, height: 100}}
          placeholder={'Please enter your inquiry here.'}/>

      <ActionButton onClick={send}>Inquire</ActionButton>
    </>}


    {rpcState.state == 'error' && <div className={'ErrorText'}>{rpcState.message}</div>}

    {rpcState.state == 'success' && <div>Your inquiry has been sent! You'll receive an email
      once the provider accepts you.</div>}

  </div>


}